'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = ButtonGroup;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _layout = require('../layout');

var _buttonGroup = require('./button-group.css');

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A basic container for grouped buttons
 * - Clones children to ensure Button components received a 'grouped' prop
 */

function ButtonGroup(props) {
  var _cx;

  var children = props.children,
      _props$wide = props.wide,
      wide = _props$wide === undefined ? true : _props$wide,
      bordered = props.bordered,
      flex = props.flex,
      spacing = props.spacing,
      reverse = props.reverse,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'wide', 'bordered', 'flex', 'spacing', 'reverse']);


  return React.createElement(
    _layout.Flex,
    (0, _extends3.default)({
      alignItems: 'center',
      className: (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _buttonGroup2.default.wide, wide), (0, _defineProperty3.default)(_cx, _buttonGroup2.default.bordered, bordered), (0, _defineProperty3.default)(_cx, _buttonGroup2.default.reverse, reverse), _cx))
    }, otherProps),
    children ? React.Children.map(children, function (child) {
      return child ? React.cloneElement(child, {
        grouped: !spacing,
        spacing: !!spacing,
        reverse: reverse,
        flex: flex
      }) : null;
    }) : null
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/button-group/button-group.js
// module id = 308
// module chunks = 114276838955818